export const popoverAnchorOriginDefault = {
  vertical: 'bottom' as 'bottom',
  horizontal: 'left' as 'left'
}

export const popoverTransformOriginDefault = {
  vertical: 'top' as 'top',
  horizontal: 'left' as 'left'
}

export const overflowModifiers = [
  {
    name: 'flip',
    enabled: true,
    options: {
      altBoundary: true,
      rootBoundary: 'viewport'
    }
  },
  {
    name: 'preventOverflow',
    enabled: true,
    options: {
      altAxis: true,
      padding: 8,
      rootBoundary: 'viewport',
      tether: false
    }
  }
]
